// The labelled read-only row on profile and detail pages: a muted label
// over the value. wraps lets sentence-length values break instead of
// staying on one line. A missing value reads "Not set" in muted text so
// blank never looks broken.

import './detail.css'

export function Detail({ label, wraps = false, children }) {
  const isEmpty = children === null || children === undefined || children === ''
  return (
    <div className="ui-detail">
      <span className="label">{label}</span>
      <div className={`ui-detail-value${wraps ? ' wraps' : ''}`}>
        {isEmpty ? <span className="ui-detail-unset">Not set</span> : children}
      </div>
    </div>
  )
}
